import { Container } from '@/components/common/container';
import { SearchResultsGridContent } from '.';

export function SearchResultsGridPage() {
  return (
    <Container>
      <SearchResultsGridContent />
    </Container>
  );
}
